import { AccordionWizard as WizardComp } from './AccordionWizard';
import { AccordionWizardStep } from './AccordionWizard.Step';
export var AccordionWizard = Object.assign(WizardComp, {
  Step: AccordionWizardStep
});